(async () => {
  const track = document.querySelector('#related-products-track');
  if (!track) return;
  const controls = document.querySelector('[data-related-controls]');
  const previous = document.querySelector('[data-related-prev]');
  const next = document.querySelector('[data-related-next]');
  const status = document.querySelector('[data-related-status]');

  const section=track.closest('.pdp-related'), message=section.querySelector('[data-related-message]');
  const current=JSON.parse(section.querySelector('[data-related-current]').textContent);
  const currentProfile=globalThis.MonacoRelated.rankingProfile(current);
  if(!section.dataset.relatedFeed){message.textContent='A specific collection is not available for this item.';track.hidden=true;return;}
  try {
    let url=new URL(section.dataset.relatedFeed,location.origin),scanned=0,total=null;const rows=[],seenPages=new Set(),collectionPath=url.pathname;
    while(url){
      if(url.origin!==location.origin||url.pathname!==collectionPath||seenPages.has(url.href))throw Error('Invalid catalog page');seenPages.add(url.href);
      const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});if(!response.ok)throw Error('Catalog unavailable');
      const page=await response.json();if(!Number.isInteger(page.total)||page.total<0||page.total>25000||!Number.isInteger(page.scanned)||page.scanned<0||page.scanned>250||!Array.isArray(page.products)||page.products.length>page.scanned)throw Error('Invalid catalog');
      if(total!==null&&total!==page.total)throw Error('Catalog changed');total=page.total;scanned+=page.scanned;if(scanned>total||page.next&&page.scanned===0)throw Error('Incomplete collection');rows.push(...page.products);
      if(page.next){url=new URL(page.next,url);url.searchParams.set('view','preview-related-data');}else url=null;
    }
    if(scanned!==total)throw Error('Incomplete catalog');
    const matches=globalThis.MonacoRelated.rankCollection(current,rows),list=track.querySelector('.pdp-related-list');
    for(const p of matches){const template=document.createElement('template');template.innerHTML=p.card;const item=template.content.querySelector('li');if(!item)throw Error('Invalid product card');item.dataset.relatedProduct=p.id;list.append(item);}
    message.textContent=matches.length?'':(currentProfile.diamondStud?'No other matching diamond studs are currently available in this collection.':'No other available products are currently in this collection.');message.hidden=!!matches.length;
    section.dataset.relatedComplete='true';section.dataset.relatedScanned=String(scanned);
  }catch(error){track.querySelector('.pdp-related-list').replaceChildren();track.hidden=true;message.textContent='Matching products could not be loaded. Please refresh to try again.';section.dataset.relatedComplete='false';return;}

  const items = [...track.querySelectorAll('.pdp-related-list > li')];
  if (!items.length) { controls.hidden = true; track.hidden = true; return; }
  const phone = window.matchMedia('(max-width: 760px)');
  const tablet = window.matchMedia('(max-width: 1024px)');
  const size = () => phone.matches ? 2 : tablet.matches ? 3 : 4;
  let start = 0;
  const last = () => Math.floor((items.length - 1) / size()) * size();
  const updateControls = () => {
    previous.setAttribute('aria-disabled', String(start === 0));
    const atEnd = phone.matches ? track.scrollLeft >= track.scrollWidth - track.clientWidth - 2 : start >= last();
    next.setAttribute('aria-disabled', String(atEnd));
    status.textContent = (start + 1) + '\u2013' + Math.min(start + size(), items.length) + ' of ' + items.length;
  };
  const mobilePosition = index => items[index].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
  const render = () => {
    items.forEach((item, index) => { item.hidden = !phone.matches && (index < start || index >= start + size()); });
    updateControls();
  };
  const move = page => {
    start = Math.max(0, Math.min(page, last()));
    render();
    if (phone.matches) track.scrollTo({left: mobilePosition(start), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  };
  track.addEventListener('scroll', () => {
    if (!phone.matches) return;
    const step = items.length > 1 ? mobilePosition(1) : track.clientWidth;
    start = Math.max(0, Math.min(Math.round(track.scrollLeft / Math.max(1, step)), items.length - 1));
    updateControls();
  }, {passive:true});
  previous.addEventListener('click', () => move(start - size()));
  next.addEventListener('click', () => move(start + size()));
  track.addEventListener('keydown', event => {
    if (event.target !== track) return;
    if (event.key === 'ArrowLeft' || event.key === 'PageUp') move(start - size());
    else if (event.key === 'ArrowRight' || event.key === 'PageDown') move(start + size());
    else if (event.key === 'Home') move(0);
    else if (event.key === 'End') move(last());
    else return;
    event.preventDefault();
  });
  const resize = () => {
    const focused = items.findIndex(item => item.contains(document.activeElement));
    const anchor = focused < 0 ? start : focused;
    start = Math.floor(anchor / size()) * size();
    render();
    track.scrollTo({left: phone.matches ? mobilePosition(start) : 0, behavior:'auto'});
  };
  if (phone.addEventListener && tablet.addEventListener) {
    phone.addEventListener('change', resize);
    tablet.addEventListener('change', resize);
  } else window.addEventListener('resize', resize, {passive:true});
  controls.hidden = false;
  render();
})();

